module.exports = __webpack_public_path__ + "static/media/bg_minecraft-1.3a68a0f4.jpg";